import React, { useContext } from 'react';
import './styles.css';
import P from 'prop-types';
import { GlobalContext } from '../../contexts/HomeContext';
import { toast } from 'react-toastify';

export const Tabs = ({
  active = 0,
  setTabActive,
  text1 = 'tab1',
  text2 = '',
  text3 = '',
  text4 = '',
  text5 = '',
  codigo_principal = 0,
}) => {
  const { dadosApp } = useContext(GlobalContext);
  const multPrecos = dadosApp.Cardapio.MultPreco.filter((p) => p.codigo_principal === codigo_principal);

  const itemsTab = [];
  if (active == 999) {
    itemsTab.push({ id: 999, text: text1, active: 999 == active ? true : false });
  } else {
    for (let i = 0; i < 5; i++) {
      const productSelected = dadosApp.Cardapio.Produtos.filter((item) => item.codigo === multPrecos[i]?.codigo_mult);

      let text = '';
      if (i == 0) text = text1;
      if (i == 1) text = text2;
      if (i == 2) text = text3;
      if (i == 3) text = text4;
      if (i == 4) text = text5;
      if (text != '')
        itemsTab.push({
          id: i,
          text: text,
          active: i == active ? true : false,
          bloqueado: productSelected[0]?.bloqueado,
        });
    }
  }

  const handleSetTabActive = (id) => {
    if (active == 999) return;
    if (active != id) setTabActive(id);
  };

  return (
    <div className="tab_container">
      {itemsTab.map((p) => (
        <div
          key={p.id}
          className="tabs"
          onClick={() =>
            p.bloqueado === 1
              ? toast.error('Produto não disponível', { containerId: 'modalToast' })
              : handleSetTabActive(p.id)
          }
          style={{
            //: p.bloqueado === 1 ? 'none' : 'flex',
            color: p.active ? 'red' : p.bloqueado === 1 ? 'rgba(115,115,115,0.1)' : '#737373',
            background: p.active ? '#FFFFFF' : '#f7f7f7', // F9F9F9
            //borderBottom: p.active ? '3px solid #ffffff' : '1px solid #ebebeb',
            border: p.active ? '2px solid #dcdcdc' : '2px solid #ebebeb',
            borderBottom: p.active ? '1px solid #fff' : '1px solid #ebebeb',
            fontWeight: p.active ? 600 : 600,
            height: p.active ? 50 : 46,
            marginTop: p.active ? 4 : 8,
            //lineHeight: p.active ? 3.7 : 3.3,
          }}
        >
          {p.text}
        </div>
      ))}
    </div>
  );
};

Tabs.propTypes = {
  active: P.number,
  setTabActive: P.func.isRequired,
  text1: P.string.isRequired,
  text2: P.string,
  text3: P.string,
  text4: P.string,
  text5: P.string,
  codigo_principal: P.number,
};
